import './Paper.scss';

import PropTypes from 'prop-types';
import React from 'react';
import Constants from 'Shared/constants';

const Paper = props => {
	const {
		element: TagName,
		elevation,
		roundness,
		outline,
		width,
		children,
		darkened,
		spacing,
		height,
		className,
		onClick,
		data,
		style,
		title,
		titleClassName,
		fade
	} = props;

	return (
		<>
			<TagName
				className={`react__paper ${className}`}
				data-darkened={darkened}
				data-elevation={elevation}
				data-fade={fade}
				data-outline={outline}
				data-roundness={roundness}
				data-spacing={spacing}
				data-title={title}
				role='button'
				style={{ ...style, width, height }}
				tabIndex={0}
				onClick={() => onClick()}
				{...data}
			>
				{title && <div className={`react__paper__title ${titleClassName}`}>{title}</div>}
				{children}
			</TagName>
		</>
	);
};

Paper.propTypes = {
	element: PropTypes.oneOf(['div', 'section']),
	elevation: PropTypes.oneOf([...Constants.SHADOWS, 'none']),
	roundness: PropTypes.oneOf([...Constants.ROUNDINGS, 'none']),
	outline: PropTypes.bool,
	darkened: PropTypes.bool,
	fade: PropTypes.bool,
	spacing: PropTypes.oneOf([...Constants.SIZES, 'none']),
	width: PropTypes.string,
	height: PropTypes.string,
	className: PropTypes.string,
	children: PropTypes.node.isRequired,
	onClick: PropTypes.func,
	data: PropTypes.object,
	style: PropTypes.object,
	title: PropTypes.string,
	titleClassName: PropTypes.string
};

Paper.defaultProps = {
	element: 'div',
	elevation: 'none',
	roundness: 'none',
	outline: false,
	fade: false,
	darkened: false,
	spacing: 'l',
	width: '100%',
	height: 'auto',
	className: '',
	onClick: () => {},
	data: {},
	style: {},
	title: null,
	titleClassName: null
};

export default Paper;
